
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, union_type, anonRecord_type, list_type, option_type, float64_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Dispolist_$reflection, Element$_$reflection, DispolistElement_$reflection } from "../../Shared/Dispolist.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";
import { TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, FormKind_$reflection, AccountSettings_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetDescription", "SetQuantity", "AddElements", "SetBusinessUnit", "RemoveElement", "DispolistFetched", "SaveDispolist", "ToolsFetched", "DispolistSaved", "AccountSettingsFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("InventoryLists.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item1", class_type("System.Guid")], ["Item2", option_type(float64_type)]], [["Item", list_type(DispolistElement_$reflection())]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [["Item", Element$_$reflection()]], [["Item", Dispolist_$reflection()]], [], [["Item", list_type(DispolistElement_$reflection())]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", AccountSettings_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(FormKind, Dispolist, FormState, Elements, UserData, BusinessUnits, AccountSettings) {
        super();
        this.FormKind = FormKind;
        this.Dispolist = Dispolist;
        this.FormState = FormState;
        this.Elements = Elements;
        this.UserData = UserData;
        this.BusinessUnits = BusinessUnits;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("InventoryLists.Form.Types.State", [], State, () => [["FormKind", FormKind_$reflection()], ["Dispolist", RequestedValue$1_$reflection(Dispolist_$reflection())], ["FormState", FormState_$reflection()], ["Elements", RequestedValue$1_$reflection(list_type(DispolistElement_$reflection()))], ["UserData", TokenDataDto_$reflection()], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

